import { CompanyInfo, Config } from '@websky/core/src/context';
import i18next from 'i18next';
import { Card, CardType } from '@websky/core/src/PromoLoader/types';
import { OauthServiceType } from '@websky/graphql';
import { Steps } from '@websky/core/src/BaseComponents/Stepbar/types';

export const promoLoaders: Card[] = [
	{
		type: CardType.City,
		city: '',
		title: '',
		text: '',
		image: 'https://cdn.websky.aero/content/frontend/images/R3/banners/loader.gif'
	}
];

const host = 'https://www.yakutia.aero';
const isProd = process.env.NODE_ENV === 'production';

const companyInfo: CompanyInfo = {
	iataCode: 'R3',
	ticketNumberCode: '849',
	subsidyFaresConditionURL: '',
	loyaltyProgramName: 'Якутия Привилегия',
	loyaltyProgramRegistrationUrl: `${host}/yakutia-freeflight/registratsiya-v-programme/`,
	privacyPolicy: 'https://e-disclosure.ru/portal/company.aspx?id=27461',
	instagram: '',
	vk: 'https://vk.com/yakutia.aero',
	baggage: `${host}/bagazh/vse-o-bagazhe/`,
	meal: `${host}/uslugi/dopolnitelnaya-usluga-pitanie/`,
	seat: `${host}/uslugi/platnyy-vybor-mest/`,
	legal: `${host}/informatsiya/oformlyayushchim-na-sayte-aviakompanii.php`,
	webskySearchOrder: `https://ticket.yakutia.aero/websky/search#/search-order`,
	insurance: 'https://www.alfastrah.ru/docs/rules_SP_230617.pdf',
	loyaltyProgramAccountUrl: `${host}/yakutia-freeflight/uchastie-v-programme/`,
	exarePrivacyPolicyURL: `${host}/personal-data/`,
	exareRulesURL: '',
	baggageAnimalsURL: '',
	loyalty: {
		links: [
			{
				title: 'Status',
				url: `${host}/yakutia-freeflight/urovni-uchastiya-v-programme/`
			},
			{
				title: 'Earn miles',
				url: `${host}/yakutia-freeflight/nachislenie-mil.php`
			},
			{
				title: 'Use miles',
				url: `${host}/yakutia-freeflight/ispolzovanie-mil/`
			},
			{
				title: 'FAQ',
				url: `${host}/yakutia-freeflight/osnovnye-ponyatiya-terminy-i-opredeleniya/`
			}
		]
	}
};

export const i18n: i18next.Resource = {
	ru: {
		Loyalty: {
			'Log in to LightJet Club': 'Вход в личный кабинет Якутия Привилегия'
		},
		Checkout: {
			Agreement: `Я ознакомлен и согласен с <a href="${host}/informatsiya/oformlyayushchim-na-sayte-aviakompanii.php" target="_blank">правилами бронирования</a>, правилами предоставления дополнительных услуг, правилами <a href="${host}/informatsiya/transportnaya-bezopasnost/" target="_blank">транспортной безопасности</a> и <a href="https://e-disclosure.ru/portal/company.aspx?id=27461" target="_blank">правами субъекта персональных данных</a>. Я согласен и подтверждаю согласие третьих лиц, указанных мной в бронировании, на обработку персональных данных, в том числе на их передачу третьим лицам, обеспечивающим или обслуживающим перевозку, а также на трансграничную передачу персональных данных.`
		},
		Consents: {
			agreement_rules: 'Я подтверждаю, что ознакомлен(а) и  соглашаюсь с {{links}}',
			agreement_generalRules: `<span><a href='https://www.yakutia.aero/informatsiya/oformlyayushchim-na-sayte-aviakompanii.php' target='_blank'>правилами бронирования</a></span>`,
			agreement_gdsRules: ' и оплатой выбранных дополнительных услуг',
			agreement_insurancesRules: 'c правилами страхования, {{insurancesProductsLinks}}'
		},
		AdditionalBaggage: {
			'Buy now and save 20-30%': 'Сэкономьте время в аэропорту'
		}
	},
	en: {
		Loyalty: {
			'Log in to LightJet Club': 'Log in to Yakutia Privilege'
		},
		Checkout: {
			Agreement: `I have read and agree to the <a href="${host}/informatsiya/oformlyayushchim-na-sayte-aviakompanii.php" target="_blank">booking rules</a>, rules for the provision of additional services, <a href="${host}/informatsiya/transportnaya-bezopasnost/" target="_blank">transportation security rules</a> and <a href="https://e-disclosure.ru/portal/company.aspx?id=27461" target="_blank">rights of the subject of personal data</a>. I agree and confirm the consent of the third parties specified by me in the booking, to the processing of personal data, including their transfer to third parties providing or servicing transportation, as well as to the cross-border transfer of personal data.`
		},
		Consents: {
			agreement_rules: 'I confirm that I have read and agree to {{links}}',
			agreement_generalRules: `<span><a href='https://www.yakutia.aero/informatsiya/oformlyayushchim-na-sayte-aviakompanii.php' target='_blank'>booking rules</a></span>`,
			agreement_gdsRules: ' and payment for selected additional services',
			agreement_insurancesRules: 'with insurance rules, {{insurancesProductsLinks}}'
		},
		AdditionalBaggage: {
			'Buy now and save 20-30%': 'Save time at the airport'
		}
	}
};

export const defaultSteps: Steps = {
	flights: {
		label: 'Flights'
	},
	seats: {
		label: 'Seats'
	},
	baggage: {
		label: 'Baggage'
	},
	meal: {
		label: 'Meal'
	},
	passengers: {
		label: 'Passengers'
	},
	insurance: {
		label: 'Insurance'
	},
	payment: {
		label: 'Payment'
	}
};

export const config: Config = {
	SearchForm: {
		payByMiles: true,
		showFfpBonusInfoInFares: true,
		offerHotels: false,
		showPricesInDatepicker: true,
		enableComplexRoute: true,
		startSearchButtonMode: 'text'
	},
	Account: {
		engineURL: '/wx'
	},
	Engine: {
		promoLoaders: promoLoaders,
		defaultSteps
	},
	global: {
		showTaxesInfo: true,
		companyInfo,
		i18n,
		allowPromoCodes: true,
		socialAuthCallbackUrl: 'https://www.yakutia.aero/wx/social-auth',
		socialAuthMethods: [{ service: OauthServiceType.Vkontakte, isAvailable: true }],
		seatMap: {
			showRecommendedSeats: true
		},
		FFPRegex: /^\d{7}$/,
		insurance: {
			allowImplicitConfirm: false
		},
		reserveEngines: {
			checkin: 'https://checkin.yakutia.aero/web-checkin/',
			redirectToWebsky1: true,
			siteUrl: 'https://www.yakutia.aero/'
		},
		additionalResources: {
			extraSvgs: ['https://cdn.websky.aero/content/R3/images/icons.svg']
		},
		showBookingPreview: false,
		collectMetrics: false,
		showFareGroupUpgradeOptions: false
	},
	FlightStatus: {
		playMarketURL: '',
		appStoreURL: ''
	}
};
